var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "flowGrid"
  }, _vm._l(_vm.skills, function ({
    items
  }, index) {
    return _c("section", {
      key: index,
      class: ["flowGridItem" + " " + (index % 2 === 0 ? "flowRight" : "flowLeft")]
    }, [_c("div", {
      staticClass: "flowGridItemList"
    }, _vm._l(items, function ({
      title,
      desc
    }) {
      return _c("div", {
        key: title,
        staticClass: "flowGridItemList-item"
      }, [_c("h3", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))])]);
    }), 0)]);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };